export interface CryptoBasketCoin {
  id: string
  symbol: string
  name: string
  coin_info_symbol: string
  icon_url: string
}

export interface CryptoBasket {
  id: string
  title: string
  description: string
  status: string
  coins: CryptoBasketCoin[]
  banner_url: string
  icon_url: string
  position: number | null
  label: string | null
  created_at: string
  updated_at: string
  price_change: {
    percentage: string
    period: string
  }
}

export interface CryptoBasketResponse {
  crypto_baskets: CryptoBasket[]
}

export interface YieldProductItem {
  id: string
  name: string
  symbol: string
  coin_info_symbol: string
  icon_url: string
  apr: string // Annual Yield Rate as string type
  product_card: string
  product_type: string
}

export enum InvestCardType {
  Basket = 'basket',
  Stake = 'stake',
  Earn = 'earn',
  Recurring = 'recurring',
  Exchange = 'exchange',
}

export enum MoreCardType {
  Coin = 'coin',
  Basket = 'basket',
}
